/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function() {

	return {
		DROP_TARGET_OPTIONS: {
			NONFILTER: 'nonFilter',
			SLOT: 'slot',
			FILTER: 'filter'
		}
	};
});
